import React, { ComponentPropsWithoutRef } from 'react'
import { cx } from 'tusk-ui/utils'
import Input from './Input'

interface TextInputProps extends ComponentPropsWithoutRef<typeof Input>, ComponentPropsWithoutRef<'input'> {}

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(({ className, invalid, ...props }, ref) => {
    return (
        <Input ref={ref} invalid={invalid} className={cx('', className)}>
            <input {...props} />
        </Input>
    )
})

export default TextInput
